import type { CountryCode, LanguageCode } from "@/services/translation";
import { CountryCode2LanguageCodeMap, FallbackCountryCode, getLanguageObject, gettext } from "@/services/translation";
import { useRouter } from "vue-router";

export function useTranslation() {
  const currentLocale = computed(() => getLanguageObject(gettext.current));

  const router = useRouter();
  const switchLanguage = (newLanguage: LanguageCode) => {
    if (currentLocale.value.code === newLanguage) {
      return;
    }

    const countryCode = Object.keys(CountryCode2LanguageCodeMap).find((key) => CountryCode2LanguageCodeMap[key as CountryCode] === newLanguage) ?? FallbackCountryCode;
    const currentRoute = router.currentRoute.value;
    const newRoute = {
      name: currentRoute.name,
      query: currentRoute.query,
      hash: currentRoute.hash,
      meta: currentRoute.meta,
      matched: currentRoute.matched,
      redirected: currentRoute.redirectedFrom,
      params: {
        ...currentRoute.params,
        countryCode,
      },
    };
    const url = router.resolve(newRoute);
    window.location.href = url.fullPath;
  };

  return {
    currentLocale,
    switchLanguage,
  };
}
